"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageIfAvailable = exports.hasWindowLocalStorage = exports.chromeStorageIfAvailable = exports.hasChromeStorage = exports.configurationStorageFactory = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const chrome_storage_async_map_1 = require("./cache/chrome-storage-async-map");
const chrome_storage_engine_1 = require("./chrome-storage-engine");
const isolatable_hybrid_store_1 = require("./isolatable-hybrid.store");
const local_storage_engine_1 = require("./local-storage-engine");
const string_valued_store_1 = require("./string-valued.store");
function configurationStorageFactory({ maxAgeSeconds = 0, servingStoreUpdateStrategy = 'always', hasChromeStorage = false, hasWindowLocalStorage = false, persistentStore = undefined, forceMemoryOnly = false, }, { chromeStorage, windowLocalStorage, storageKeySuffix, } = {}) {
    if (forceMemoryOnly) {
        return new js_client_sdk_common_1.MemoryOnlyConfigurationStore();
    }
    else if (persistentStore) {
        return new isolatable_hybrid_store_1.IsolatableHybridConfigurationStore(new js_client_sdk_common_1.MemoryStore(), persistentStore, servingStoreUpdateStrategy);
    }
    else if (hasChromeStorage && chromeStorage) {
        // Chrome storage is available, use it as a fallback
        const chromeStorageEngine = new chrome_storage_engine_1.ChromeStorageEngine(new chrome_storage_async_map_1.default(chromeStorage), storageKeySuffix !== null && storageKeySuffix !== void 0 ? storageKeySuffix : '');
        return new isolatable_hybrid_store_1.IsolatableHybridConfigurationStore(new js_client_sdk_common_1.MemoryStore(), new string_valued_store_1.StringValuedAsyncStore(chromeStorageEngine, maxAgeSeconds), servingStoreUpdateStrategy);
    }
    else if (hasWindowLocalStorage && windowLocalStorage) {
        // window.localStorage is available, use it as a fallback
        const localStorageEngine = new local_storage_engine_1.LocalStorageEngine(windowLocalStorage, storageKeySuffix !== null && storageKeySuffix !== void 0 ? storageKeySuffix : '');
        return new isolatable_hybrid_store_1.IsolatableHybridConfigurationStore(new js_client_sdk_common_1.MemoryStore(), new string_valued_store_1.StringValuedAsyncStore(localStorageEngine, maxAgeSeconds), servingStoreUpdateStrategy);
    }
    // No persistence store available, use memory only
    return new js_client_sdk_common_1.MemoryOnlyConfigurationStore();
}
exports.configurationStorageFactory = configurationStorageFactory;
function hasChromeStorage() {
    return typeof chrome !== 'undefined' && !!chrome.storage;
}
exports.hasChromeStorage = hasChromeStorage;
function chromeStorageIfAvailable() {
    return hasChromeStorage() ? chrome.storage.local : undefined;
}
exports.chromeStorageIfAvailable = chromeStorageIfAvailable;
/** Returns whether `window.localStorage` is available */
function hasWindowLocalStorage() {
    try {
        return typeof window !== 'undefined' && !!window.localStorage;
    }
    catch (_a) {
        // Chrome throws an error if local storage is disabled, and you try to access it
        return false;
    }
}
exports.hasWindowLocalStorage = hasWindowLocalStorage;
function localStorageIfAvailable() {
    return hasWindowLocalStorage() ? window.localStorage : undefined;
}
exports.localStorageIfAvailable = localStorageIfAvailable;
//# sourceMappingURL=configuration-factory.js.map